import bg from './locales/bg/translations.json';
import cs from './locales/cs/translations.json';
import de from './locales/de/translations.json';
import en from './locales/en/translations.json';
import es from './locales/es/translations.json';
import fr from './locales/fr/translations.json';
import hu from './locales/hu/translations.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import pl from './locales/pl/translations.json';
import ro from './locales/ro/translations.json';
import ru from './locales/ru/translations.json';
import tr from './locales/tr/translations.json';
import uk from './locales/uk/translations.json';
import zh from './locales/zh/translations.json';

export const defaultNS = 'translations';

export const supportedLanguages = [
    {
        key: 'en',
        title: 'English',
    },
    {
        // Spanish
        key: 'es',
        title: 'Español',
    },
    {
        // Chinese
        key: 'zh',
        title: '中文',
    },
    {
        // French
        key: 'fr',
        title: 'Français',
    },
    {
        // Bulgarian
        key: 'bg',
        title: 'български',
    },
    {
        // German
        key: 'de',
        title: 'Deutsch',
    },
    {
        // Hungarian
        key: 'hu',
        title: 'Magyar',
    },
    {
        // Polish
        key: 'pl',
        title: 'Polski',
    },
    {
        // Romanian
        key: 'ro',
        title: 'Română',
    },
    {
        // Russian
        key: 'ru',
        title: 'Русский',
    },
    {
        // Ukrainian
        key: 'uk',
        title: 'Українська',
    },
    {
        // Turkish
        key: 'tr',
        title: 'Türkçe',
    },
    {
        // Czech
        key: 'cs',
        title: 'Čeština',
    },
];

const resources = {
    en: {
        translations: en,
    },
    es: {
        translations: es,
    },
    zh: {
        translations: zh,
    },
    fr: {
        translations: fr,
    },
    bg: {
        translations: bg,
    },
    de: {
        translations: de,
    },
    hu: {
        translations: hu,
    },
    pl: {
        translations: pl,
    },
    ro: {
        translations: ro,
    },
    ru: {
        translations: ru,
    },
    uk: {
        translations: uk,
    },
    tr: {
        translations: tr,
    },
    cs: {
        translations: cs,
    },
};

i18n.use(initReactI18next).init({
    fallbackLng: 'en',
    lng: 'en',
    resources: resources,
    ns: ['translations'],
    defaultNS: 'translations',
});

i18n.languages = supportedLanguages.map(x => x.key);

export { i18n };